import { ListingFormatter } from '@spotahome/ui-library/src/tenant/utils/images';

import {
  IMG_TYPE,
  PLAN_TYPE,
  VIDEO_TYPE,
  MAP_TYPE,
  V360_TYPE,
  OTHER_ROOMS_TYPE,
  FULL_SCREEN_TRACKS
} from './constants';

const createTrack = (items, type) => (items.length ? { type, items } : null);

const getIMGTrack = photoList => {
  const parsedPhotoList = photoList.map(({ id, verified, caption }) => ({
    src: ListingFormatter.buildPhotoUrl(id, verified),
    srcSquare: ListingFormatter.buildSquarePhotoUrl(id),
    caption
  }));

  return createTrack(parsedPhotoList, IMG_TYPE);
};

const getMapTrack = mapProps => ({ type: MAP_TYPE, items: [mapProps] });

const getVideoTrack = (videos, mainPhoto, adTitle, videoWatermark) => {
  const sliderVideos = videos.map(video => ({
    title: adTitle,
    video,
    thumbnail: {
      detail_full_screen: ListingFormatter.buildPhotoUrl(
        mainPhoto.id,
        mainPhoto.verified
      )
    },
    watermark: videoWatermark
  }));

  return createTrack(sliderVideos, VIDEO_TYPE);
};

const getFloorPlanTrack = floorplanList => {
  const sliderPlans = floorplanList.map(floorPlanId => ({
    src: ListingFormatter.buildFloorplanPhotoUrl(floorPlanId)
  }));

  return createTrack(sliderPlans, PLAN_TYPE);
};

const get360Track = photo360List => {
  const slider360 = photo360List.map(({ id, caption }) => ({
    caption,
    id,
    src: {
      small360: ListingFormatter.build360PhotoUrl(id, 'small'),
      large360: ListingFormatter.build360PhotoUrl(id, 'large')
    }
  }));

  return createTrack([{ photos: slider360 }], V360_TYPE);
};

const getOtherRoomsTrack = hasOtherRooms =>
  hasOtherRooms
    ? {
        type: OTHER_ROOMS_TYPE
      }
    : null;

export const getBaseTracks = ({
  floorplanList,
  photoList,
  photo360List,
  videos,
  adTitle,
  mapProps,
  videoWatermark
}) => {
  const tracks = [
    photoList.length && getIMGTrack(photoList),
    mapProps && getMapTrack(mapProps),
    photoList.length &&
      videos &&
      getVideoTrack(videos, photoList[0], adTitle, videoWatermark),
    photo360List.length && get360Track(photo360List),
    floorplanList.length && getFloorPlanTrack(floorplanList)
  ];
  return tracks.filter(Boolean);
};

export const getExtraTracks = hasOtherRooms => {
  const extraTracks = [getOtherRoomsTrack(hasOtherRooms)];

  return extraTracks.filter(Boolean);
};

export const isTrackAllowedInFullScreen = track =>
  FULL_SCREEN_TRACKS.includes(track.type);

export const findVideoTrack = tracks =>
  tracks.find(track => track.type === VIDEO_TYPE);

export const findImageTrack = tracks =>
  tracks.find(track => track.type === IMG_TYPE);

export const findFloorPlanTrack = tracks =>
  tracks.find(track => track.type === PLAN_TYPE);

export const getVideoTrackIndex = tracks => {
  const index = tracks.findIndex(track => track.type === VIDEO_TYPE);

  return index >= 0 ? index : -1;
};

export const getImageTrackIndex = tracks => {
  const index = tracks.findIndex(track => track.type === IMG_TYPE);

  return index >= 0 ? index : -1;
};

export const getMapTrackIndex = tracks => {
  const index = tracks.findIndex(track => track.type === MAP_TYPE);

  return index >= 0 ? index : -1;
};

export const getFloorPlanTrackIndex = tracks => {
  const index = tracks.findIndex(track => track.type === PLAN_TYPE);

  return index >= 0 ? index : -1;
};

export default {
  getBaseTracks,
  getExtraTracks,
  findVideoTrack,
  getVideoTrackIndex,
  getMapTrackIndex,
  findImageTrack,
  getImageTrackIndex,
  findFloorPlanTrack,
  getFloorPlanTrackIndex,
  isTrackAllowedInFullScreen
};
